import { motion } from "framer-motion";

// Edit these figures anytime — they drive the social-proof band on the landing page.
const STATS = [
    { value: "12,000+", label: "Matches Coached" },
    { value: "< 3s", label: "Threat Callouts" },
    { value: "7-Axis", label: "Skill Analysis" },
    { value: "0", label: "Anti-Cheat Risk" },
];

export function SocialProof() {
    return (
        <section className="border-b border-white/10 bg-obsidian" data-testid="social-proof">
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
                {STATS.map((s, i) => (
                    <motion.div key={s.label} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }} className="text-center">
                        <div className="font-heading text-3xl md:text-4xl font-black text-volt tracking-tight">{s.value}</div>
                        <div className="mt-1 text-[11px] font-mono uppercase tracking-[0.15em] text-muted-foreground">{s.label}</div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
